import React from 'react';
import './OverTime.css';
import { useTranslation } from 'react-i18next';
import { formatStatCardFooterDate } from '../../../../../../utils/timeUtils';



export const OverTime = ({ employeeWorkDetails, project }) => {

    const {t} = useTranslation();


    // Get current month and year
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth(); // 0-indexed (January is 0)
    const currentYear = currentDate.getFullYear();

    const startDateFormatted = formatStatCardFooterDate(project.startDate);
    const endDateFormatted = formatStatCardFooterDate(project.endDate);

    // Filter work details for the current month and with overtime set to "Overtime"
    const currentMonthOvertimeDetails = employeeWorkDetails.filter(detail => {
        const workDate = new Date(detail.work_date);
        return detail.overtime === 'Overtime';
    });

    // Calculate total overtime hours and minutes for the current month
    let totalOvertimeMinutes = currentMonthOvertimeDetails.reduce((total, detail) => {
        if (detail.work_duration && typeof detail.work_duration === 'string') {
            const durationParts = detail.work_duration.split(':');
            if (durationParts.length === 3) {
                const hours = parseInt(durationParts[0], 10) || 0;
                const minutes = parseInt(durationParts[1], 10) || 0;
                total += hours * 60 + minutes;
            }
        }
        return total;
    }, 0);

    const totalOvertimeHours = Math.floor(totalOvertimeMinutes / 60);
    const totalRemainingMinutes = totalOvertimeMinutes % 60;

    return (
        <div className='WorkStat-body'>
            <div className='WorkStat-worked-headerbody'>
                <div className='WorkStat-worked-header'>
                    <span>{t("employeeWorkDetails_overtime")}</span>
                </div>
            </div>
            <div className='WorkStat-worked-duration'>
                {totalOvertimeHours} Hrs {totalRemainingMinutes} Mins
            </div>
            <div className='WorkStat-worked-footer'>
                {startDateFormatted} - {endDateFormatted}
            </div>
        </div>
    );
};

export default OverTime;
